import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
export default function UserOrders() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [orderItems, setOrderItems] = useState([]);
    const [itemLoading, setItemLoading] = useState(false);
    const [feedbackOpen, setFeedbackOpen] = useState(false);
    const [reviewTitle, setReviewTitle] = useState("");
    const [reviewMessage, setReviewMessage] = useState("");
    const [images, setImages] = useState([]);
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [orderStatuses, setOrderStatuses] = useState({});
    const [statusLoading, setStatusLoading] = useState(null);
    useEffect(() => {
        fetchOrderData();
    }, []);
    const fetchOrderData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "order/" + localStorage.getItem("userID");
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }
    const fetchOrderItems = async (orderId) => {
        setItemLoading(true);
        try {
            let url = webEndPoint + "order/details/" + orderId;
            const response = await makeRequest("get", url);
            if (response) {
                setOrderItems(response?.data);
                setSelectedOrderId(orderId);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setItemLoading(false);
        }
    };
    const fetchOrderStatus = async (orderId) => {
        setStatusLoading(orderId);
        try {
            const url = webEndPoint + "order-status-history/order/" + orderId;
            const response = await makeRequest("get", url);
            if (response) {
                const history = response?.data || [];
                setOrderStatuses((prev) => ({
                    ...prev,
                    [orderId]: history
                }));
            }
        } catch (err) {
            setOrderStatuses((prev) => ({
                ...prev,
                [orderId]: []
            }));
        } finally {
            setStatusLoading(null);
        }
    };
    const handleCloseItems = () => {
        setSelectedOrderId(null);
        setOrderItems([]);
    };
    const handleOpenFeedback = (orderId) => {
        setSelectedOrderId(orderId);
        setFeedbackOpen(true);
    };
    const handleImageChange = async (e) => {
        const files = Array.from(e.target.files);
        if (!files || files.length === 0) return;
        setLoading(true);
        try {
            const uploadedImages = [];
            for (let file of files) {
                const previewUrl = await new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(file);
                });
                const formData = new FormData();
                formData.append("file", file);
                const response = await fetch(webEndPoint + "upload", { method: "POST", body: formData, });
                const data = await response.text(); uploadedImages.push({ url: data, preview: previewUrl });
            }
            setImages((prev) => [...prev, ...uploadedImages]);
            setLoading(false);
        } catch (error) {
            console.error("Upload error:", error);
            setLoading(false);
        }
    };
    const handleSubmitFeedback = async () => {
        setLoading(true);
        const reviewData = {
            product_id: 31,
            user_id: localStorage.getItem("userID"),
            rating: rating,
            review_title: reviewTitle,
            review_message: reviewMessage,
            images: images ? images : null
        }
        try {
            let url = webEndPoint + "review";
            const response = await makeRequest("post", url, reviewData);
            if (response) {
                toast.success("Feedback submitted successfully");
                setFeedbackOpen(false);
                setRating(0);
                setReviewTitle("");
                setReviewMessage("");
                setImages([]);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const EmojiRating = ({ rating, setRating, hoverRating, setHoverRating }) => {
        const reactions = [
            { value: 1, emoji: "😡", label: "Poor" },
            { value: 2, emoji: "😕", label: "Bad" },
            { value: 3, emoji: "😐", label: "Okay" },
            { value: 4, emoji: "🙂", label: "Good" },
            { value: 5, emoji: "😍", label: "Excellent" },
        ];
        return (
            <div className="emoji-rating">
                {reactions.map((item) => (
                    <div key={item.value} className={`emoji-item ${(hoverRating || rating) === item.value ? "active" : ""}`}
                        onClick={() => setRating(item.value)}
                        onMouseEnter={() => setHoverRating(item.value)}
                        onMouseLeave={() => setHoverRating(0)}>
                        <span className="emoji">{item.emoji}</span>
                        <span className="emoji-label">{item.label}</span>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="order-info">
            <Loader loading={loading} />
            <button className="backhome-btn" onClick={() => navigate("/")}>Back to Home</button>
            <h2 className="orders-title">My Orders</h2>
            <div className="orders-wrapper">
                {dataSource?.map((order, index) => (
                    <div className="order-card" key={index}>
                        <div className="order-left">
                            <div className="order-info">
                                <p>Order ID : SA0000{order?.rfId}</p>
                                <p>Order Number : {order?.order_number}</p>
                                <p>
                                    Date : {
                                        new Date(order.created_at).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                            hour: "numeric",
                                            minute: "2-digit",
                                            hour12: true
                                        }).replace(",", "")
                                    }
                                </p>
                                <p className="order-price">Order Amount : ₹{order.final_amount}</p>
                                <p>Order Status : {order.order_status}</p>
                                {selectedOrderId === order.rfId && (
                                    <div className="order-items" style={{ marginTop: "10px", padding: "10px", background: "#f9f9f9", borderRadius: "8px" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                            <h4>Order Items</h4>
                                            <button onClick={handleCloseItems} style={{ background: "red", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "5px", cursor: "pointer" }}>Close</button>
                                        </div>
                                        {itemLoading ? (
                                            <p>Loading items...</p>
                                        ) : orderItems.length > 0 ? (
                                            orderItems.map((item, i) => (
                                                <div className="order-item-row" key={i} style={{ display: "flex", gap: "15px", alignItems: "center", marginBottom: "10px" }}>
                                                    <img src={item.color_image_url} alt={item.product_name} style={{ width: "70px", height: "70px", objectFit: "cover", borderRadius: "8px", border: "1px solid #ddd" }} />
                                                    <div>
                                                        <p><strong>{item.product_name}</strong></p>
                                                        <p>Qty: {item.quantity}</p>
                                                        <p>Price: ₹{item.price}</p>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p>No items found</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="order-right">
                            <button className="order-btn" onClick={() => fetchOrderItems(order?.rfId)}>View Order Details</button>
                            <button className="order-status-btn" onClick={() => fetchOrderStatus(order?.rfId)}>{statusLoading === order?.rfId ? "Loading..." : "Tracking Order Status"}</button>
                            {orderStatuses[order?.rfId]?.length > 0 && (
                                <div className="order-status-history">
                                    {orderStatuses[order?.rfId].map((status, statusIndex) => (
                                        <div key={statusIndex} className="status-item">
                                            <p>{status.remarks}</p>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {order?.order_status === "DELIVERED" &&
                                <button className="order-feedback-btn" onClick={() => handleOpenFeedback(order?.rfId)}>Feedback</button>
                            }
                        </div>
                    </div>
                ))}
            </div>
            {feedbackOpen && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h3>Give Feedback</h3>
                        <label className="field-label">Rating</label>
                        <EmojiRating rating={rating} setRating={setRating} hoverRating={hoverRating} setHoverRating={setHoverRating} />
                        <label className="field-label">Review Title</label>
                        <input className="input-field" type="text" placeholder="Review Title" value={reviewTitle} onChange={(e) => setReviewTitle(e.target.value)} />
                        <label className="field-label">Review Message</label>
                        <textarea className="input-field" placeholder="Write review..." value={reviewMessage} onChange={(e) => setReviewMessage(e.target.value)} />
                        <div className="upload-container">
                            <label className="upload-dropzone">
                                <input type="file" multiple accept="image/*" onChange={handleImageChange} hidden />
                                <div className="upload-content">
                                    <div className="upload-icon">📷</div>
                                    <p className="upload-text">Click or Drag & Drop Images</p>
                                    <span className="upload-subtext">JPG, PNG up to 10MB</span>
                                </div>
                            </label>
                            {images?.length > 0 && (<div className="upload-count">{images.length} image(s) selected</div>)}
                        </div>
                        <div style={{ display: "flex", gap: 10, marginTop: 15 }}>
                            <button onClick={handleSubmitFeedback} className="btn-primary">Submit</button>
                            <button onClick={() => setFeedbackOpen(false)} className="feed-btn-secondary">Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}